import React from 'react';
import MuiWavingHandIcon from '@mui/icons-material/WavingHand';

interface WaveHandIconProps {
  className?: string;
  /** CSS font-size for the icon, e.g. `1.15em` or `28px` */
  size?: string;
}

/**
 * Waving-hand greeting icon. Unicode 👋 often renders as a tofu box in Cordova
 * because Poppins does not ship emoji glyphs — use this instead.
 */
const WaveHandIcon: React.FC<WaveHandIconProps> = ({ className, size = '1.15em' }) => (
  <MuiWavingHandIcon
    className={className}
    aria-hidden
    sx={{
      fontSize: size,
      width: size,
      height: size,
      verticalAlign: 'text-bottom',
    }}
  />
);

export default WaveHandIcon;
